import 'react';
import { formatCurrency } from '@atc/string-fns';
import { Text } from 'reaxl';
import { financingDisclaimers } from 'axl-config';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const buildCashDisclaimer = (cash, tradeEquity, hasTax, contactDisclaimer, disclaimerKey, shortCustomDisclaimer) => {
  const {
    cashPrivateSellerWithNoTaxDisclaimer,
    cashPrivateSellerWithTaxDisclaimer,
    cashWithNoTaxDisclaimer,
    cashWithTaxDisclaimer,
    cashDealDisclaimerPsx,
    cashDefaultDealDisclaimer
  } = financingDisclaimers;
  let onPageCashDisclaimer = '';
  let modalText = '';
  let modalTitle = '';
  let modalTriggerText = '';
  let cashDisclaimerHasModal = false;
  switch (disclaimerKey) {
    case 'CoxAuto':
      // Esntial
      onPageCashDisclaimer = /*#__PURE__*/jsxs(Fragment, {
        children: ["*Estimated total purchase price based on advertised price of\xA0", /*#__PURE__*/jsx(Text, {
          weight: "bold",
          children: `${formatCurrency(cash)}. `
        }), "Includes estimated tax, title, document, license, registration, and delivery fees. This is not an offer or sales contract. See dealer for terms of purchase."]
      });
      modalText = `*Estimated total purchase price based on advertised price of ${formatCurrency(cash)}.
            Includes estimated tax, title, document, license, registration, and delivery fees. This is not an offer or
            sales contract. See dealer for terms of purchase.`;
      modalTitle = 'Disclaimer';
      modalTriggerText = 'Read More';
      cashDisclaimerHasModal = true;
      break;
    case 'PSX':
      onPageCashDisclaimer = /*#__PURE__*/jsxs(Fragment, {
        children: ["*", cash >= 0 && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Text, {
            weight: "bold",
            children: `${formatCurrency(cash)} `
          }), hasTax ? cashPrivateSellerWithTaxDisclaimer : cashPrivateSellerWithNoTaxDisclaimer]
        }), cashDealDisclaimerPsx, contactDisclaimer]
      });
      break;
    case 'BOA':
    case 'Accelerate':
      onPageCashDisclaimer = '*Estimated cash payment based on advertised price of ' + formatCurrency(cash) + ' plus fees. You plan to pay by cash/check or get your own financing.';

      // Set up the modal if a short custom disclaimer is provided
      if (shortCustomDisclaimer) {
        modalText = onPageCashDisclaimer + ' ' + shortCustomDisclaimer;
        modalTitle = 'Disclaimer Details';
        modalTriggerText = 'See more details';
        cashDisclaimerHasModal = true;
      }
      break;
    default:
      onPageCashDisclaimer = /*#__PURE__*/jsxs(Fragment, {
        children: ["*", cash >= 0 && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Text, {
            weight: "bold",
            children: `${formatCurrency(cash)} `
          }), hasTax ? cashWithTaxDisclaimer : cashWithNoTaxDisclaimer, /*#__PURE__*/jsx(Text, {
            weight: "bold",
            children: ` ${formatCurrency(tradeEquity)}. `
          })]
        }), cashDefaultDealDisclaimer]
      });
      break;
  }
  return {
    cashDisclaimerHasModal,
    onPageCashDisclaimer,
    modalText,
    modalTitle,
    modalTriggerText
  };
};
export { buildCashDisclaimer as default };
